import { createSelector } from 'reselect';

const columns = [
  {
    id: 'username',
    title: 'Display name',
  },
  {
    id: 'email',
    title: 'Email',
  },
  {
    id: 'group_id',
    title: 'Access group',
    type: 'select',
  },
  {
    id: 'first_seen',
    title: 'Date created',
    type: 'date',
  },
  {
    id: 'last_seen',
    title: 'Last login',
    type: 'date',
  },
];

export const getColumns = () => columns;

export const checkPlanPermission = (billingPermissions, permission) =>
  billingPermissions && billingPermissions[permission];

export const getDivisions = (state) => state.divisions || [];

export const getFormattedDivisions = (state) => {
  // Selector doesnt seem to be working arrays
  const divisions = state.divisions || [];
  return divisions.map((division) => {
    return {
      value: division.id,
      text: division.name,
    };
  });
};
